var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e4s-flex-row e4s-full-width e4s-justify-flex-center"},[_c('LoginFormV2',{attrs:{"redirected-from":_vm.redirectedFrom},on:{"onCancel":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }